/* eslint-disable @typescript-eslint/no-unused-vars */
// Added for testing
import React, { useRef, useState } from 'react';
import { Divider, Text } from 'src/@vymo/ui/atoms';
import { Form, Page } from 'src/@vymo/ui/molecules';
import { Keys, locale } from 'src/i18n';
import { FormVersion } from 'src/models/filters/types';
import {
  getPendingActivities,
  getRevyreConfig,
} from 'src/models/lmsConfig/selectors';
import { useAppSelector } from 'src/store/hooks';
import ChildComponent from 'src/workspace/childComponent';
import { getNotificationInputs } from './queries';

function RevyreNotificationPopup(props) {
  const formRef = useRef<any>(null);
  const pendingActivities = useAppSelector((state) =>
    getPendingActivities(state),
  );
  const workflowConfig = useAppSelector(getRevyreConfig) || {};
  const firstPendingActivity = pendingActivities?.[0]?.mutatedEntity;
  const [selectedActivity, setSelectedActivity] = useState<string | null>(null);
  const [selectedAction, setSelectedAction] = useState<string | null>(null);
  const notificationInputs = getNotificationInputs(firstPendingActivity);

  const onFormChange = (formFields) => {
    if (formFields.activity_list) {
      setSelectedActivity(formFields.activity_list.value);
    }
    if (formFields.activitySelection) {
      setSelectedAction(
        formFields.activitySelection.additionalData?.data?.code,
      );
      if (
        formFields.activitySelection.additionalData?.data?.code === 'create'
      ) {
        setSelectedActivity(null);
      }
    }
  };
  return (
    <Page>
      <Page.Header>
        <Text bold type="h4">
          {locale(Keys.PENDING_ACTIVITIES)}
        </Text>
      </Page.Header>

      <Page.Body>
        <Form
          ref={formRef}
          id="notificationForm"
          name="notificationForm"
          config={{
            version: FormVersion.webRevyre,
            data: [...notificationInputs],
            grouping: [],
            fieldItemConfig: {
              showDisabledIcon: true,
            },
            viewMode: false,
            metaData: {
              workflowConfig,
            },
          }}
          onChange={onFormChange}
        />
        {(selectedActivity || selectedAction === 'create') && (
          <>
            <Divider />
            <ChildComponent
              id="REVYRE_FORM"
              props={{
                ...props,
                domainType: 'activity',
                type: selectedAction,
                showTitle: false,
              }}
            />
          </>
        )}
      </Page.Body>
    </Page>
  );
}

export default RevyreNotificationPopup;
